<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3>Aggregator Detail</h3>
      <p>Informasi detail mengenai aggregator</p>
    </div>

    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>
    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Detail Aggregator</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 50px 20px 50px' }" v-if="!loading">
        <v-row>
          <v-col cols="10" sm="4"> QR Type </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.qr_type }}
          </v-col>
        </v-row>
        <v-row
          style="align-items: center"
          v-show="
            data != null && (data.id_qr_type == '4' || data.id_qr_type == '5')
          "
        >
          <v-col cols="10" sm="4" />
          <v-col cols="2" sm="1" />
          <v-col cols="12" sm="7">
            <v-radio-group
              class="ma-0"
              v-model="notifSticker"
              column
              disabled
              readonly
              dense
            >
              <template v-slot:label>
                <div>
                  Apakah anda membutuhkan <strong>notif transaksi</strong> via
                  API untuk merchant sticker anda?
                </div>
              </template>
              <v-radio label="Ya" value="1" />
              <v-radio label="Tidak" value="0" />
            </v-radio-group>
          </v-col>
        </v-row>
      </div>
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Data PIC</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 50px 20px 50px' }" v-if="!loading">
        <v-row>
          <v-col cols="10" sm="4"> Nama PIC </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.aggre_pic_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nomor KTP PIC </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.aggre_pic_ktp_no }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Jabatan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.aggre_pic_jabatan }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> No Handphone </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.aggre_pic_mobile_phone }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Email </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.aggre_pic_email }}
          </v-col>
        </v-row>
      </div>
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">Data Aggregator</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 50px 20px 50px' }" v-if="!loading">
        <v-row>
          <v-col cols="10" sm="4"> Source Onboarding </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.source_onboarding_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nama Perusahaan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.merchant_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nama Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.owner_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nomor Rekening Perusahaan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.account_number }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nomor KTP Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.ktp_no }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Nomor NPWP
            {{
              accountType == 'Corporate' ? 'Perusahaan' : 'Pemilik Usaha'
            }}</v-col
          >
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.npwp_no }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4"> No Telepon </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : aggregatorPhone }}</v-col
          >
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Email </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.email }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Alamat Perusahaan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.address }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Kota, Kecamatan, Kode Pos </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{
              data == null
                ? ''
                : data.kabupaten_kota +
                  ', ' +
                  data.kecamatan +
                  ', ' +
                  data.kode_pos
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> KODE BC/KO </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.bcko) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Merchant Category Segment </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.cmer) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Referral Code </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.referral_code) }}
          </v-col>
        </v-row>
        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3 class="mb-5">Endpoint</h3>
          </div>
        </v-card>
        <v-row>
          <v-col cols="10" sm="4"> URL </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.endpoint) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> IP Address </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.ip_address) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> ID Approver 1 </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.approver_1 }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> ID Approver 2 </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.approver_2 }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              small
              color="orange"
              dark
              :style="{ margin: '2px' }"
              @click="back"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>
              Back
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { text, date } from '../../../lib/helpers';

export default {
  mixins: [validationMixin],
  validations: {
    remark: { required },
  },
  mounted() {
    this.getDetailData();
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    data() {
      return this.$store.state.client.aggregator.aggregator;
    },
    accountType() {
      return this.data != null ? this.data.account_type : null;
    },
    aggregatorPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    notifSticker() {
      try {
        return this.data == null
          ? ''
          : this.data.notif_sticker_status.toString();
      } catch {
        return '';
      }
    },
  },
  methods: {
    async getDetailData() {
      this.loading = true;

      await this.$store
        .dispatch('client/aggregator/viewAggregator', {
          id: this.$route.params.id,
          date,
        })
        .then(() => {
          if (this.data == null) {
            throw this.data;
          }
        })
        .catch(() => {
          this.$router.back();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    back() {
      this.$router.back();
    },

    text,
  },
};
</script>
